import { render, staticRenderFns } from "./FeedAddFilter.vue?vue&type=template&id=1587e7e8&scoped=true&"
import script from "./FeedAddFilter.vue?vue&type=script&lang=js&"
export * from "./FeedAddFilter.vue?vue&type=script&lang=js&"
import style0 from "./FeedAddFilter.vue?vue&type=style&index=0&id=1587e7e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1587e7e8",
  null
  
)

export default component.exports